/**
 * Generated file
 * Do not edit directly
 */
import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

export const OverflowIcon = ({ css, ...props }: IconProps) => {
  return (
    <Icon
      height="16px"
      width="16px"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.16659 8.00001C9.16659 8.64434 8.64429 9.16668 7.99999 9.16668C7.3557 9.16668 6.8334 8.64434 6.8334 8.00001C6.8334 7.35568 7.3557 6.83334 7.99999 6.83334C8.64429 6.83334 9.16659 7.35568 9.16659 8.00001ZM5.50006 8.00003C5.50006 8.64437 4.97776 9.1667 4.33347 9.1667C3.68917 9.1667 3.16687 8.64437 3.16687 8.00003C3.16687 7.3557 3.68917 6.83337 4.33347 6.83337C4.97776 6.83337 5.50006 7.3557 5.50006 8.00003ZM11.6665 9.16668C12.3108 9.16668 12.8331 8.64434 12.8331 8.00001C12.8331 7.35568 12.3108 6.83334 11.6665 6.83334C11.0222 6.83334 10.4999 7.35568 10.4999 8.00001C10.4999 8.64434 11.0222 9.16668 11.6665 9.16668Z"
        fill="currentColor"
      ></path>
    </Icon>
  );
};
